import { toPlaceSuggestions } from '@data/api/mappers/places/toPlaceSuggestion'
import { RequestInfo, requester } from '@data/api/requester'
import { fifteenMinutes } from '@data/constants/time'
import { InfiniteQueryOptions, InfiniteQueryResult, useInfiniteQuery } from '@data/queries/util/useInfiniteQuery'
import { QueryFunctionContext } from '@tanstack/react-query'

type LocationSuggestionRequestArgs = {
    query: string
    sessionToken: string
    type?: 'city' | 'location'
    limit?: number
    offset?: number
}

const locationSuggestionRequest = ({
    query,
    sessionToken,
    type = 'city',
    limit = 5,
    offset = 0,
}: LocationSuggestionRequestArgs): RequestInfo<TOffsetPaginatedList<TPlaceSuggestion>> => {
    const params = {
        query,
        type,
        sessionToken,
        limit,
        offset,
    }

    return {
        method: 'GET',
        url: `/location/suggestion`,
        params,
        responseMapper: toPlaceSuggestions,
    }
}

type LocationSuggestionQueryKey = ['location-suggestion', LocationSuggestionRequestArgs]

type QueryFnParams = QueryFunctionContext<LocationSuggestionQueryKey, number>

const queryFn = ({ queryKey, pageParam = 0 }: QueryFnParams) => {
    return requester(locationSuggestionRequest({ ...queryKey[1], offset: pageParam }))
}

export const useLocationSuggestion = (
    requestArgs: LocationSuggestionRequestArgs,
    options?: InfiniteQueryOptions<TPlaceSuggestion, LocationSuggestionQueryKey>
): InfiniteQueryResult<TPlaceSuggestion, LocationSuggestionQueryKey> =>
    useInfiniteQuery({
        staleTime: Infinity,
        gcTime: fifteenMinutes,
        ...options,
        queryKey: ['location-suggestion', requestArgs],
        queryFn,
    })
